<template>
  <div class="step-consultations">

    <div class="form-group" v-if="['cpf', 'cnpj'].includes(tag)">
      <div class="form-check pr-2 inline-block">
        <input type="radio" name="consultation-by" id="consultation-by-list" class="form-check-input" value="1" v-model="mode" @change="cleanSelections">
        <label class="label" for="consultation-by-list">Selecionar Consultas Individuais</label>
      </div>
      <div class="form-check inline-block">
        <input type="radio" name="consultation-by" id="consultation-by-template" class="form-check-input" value="2" v-model="mode" @change="cleanSelections">
        <label class="label" for="consultation-by-template">Consultar por Template</label>
      </div>
    </div>

    <validation-provider v-slot="{ errors }" rules="required" v-if="mode === '1'">
      <div class="group-fields">
        <legend class="groupTitle">Selecionar Consultas Individuais</legend>

        <div class="form-group" :class="{ '-has-error': errors.length > 0 }">
          <multiselect
            :options="consultations"
            :multiple="true"
            class="form-control"
            label="label"
            track-by="name"
            id="consultations"
            placeholder="Selecione uma opção"
            select-label="Pressione enter para selecionar"
            selected-label="Selecionado"
            deselect-label="Pressione enter para remover"
            v-model="form.consultations"
          ></multiselect>
          <div class="form-check">
            <input
              type="checkbox"
              class="form-check-input"
              id="select-all"
              name="select-all"
              @change="$event.target.checked ? selectAllAvailableConsultations() : deselectAllAvailableConsultations()"
            >
            <label for="select-all">Selecionar todas</label><br>
          </div>
          <p class="description" v-if="errors.length > 0">{{ errors[0] }}</p>
        </div>
      </div>
    </validation-provider>

    <validation-provider v-slot="{ errors }" rules="required" v-if="mode === '2'">
      <div class="group-fields">
        <legend class="groupTitle">Consultar por Template</legend>

        <div class="form-group" :class="{ '-has-error': errors.length > 0 }">
          <multiselect
            :options="templates"
            :multiple="false"
            class="form-control"
            label="name"
            track-by="id"
            id="templates"
            placeholder="Selecione uma opção"
            select-label="Pressione enter para selecionar"
            selected-label="Selecionado"
            deselect-label="Pressione enter para remover"
            v-model="form.template"
            :allow-empty="true"
          ></multiselect>
          <p class="description" v-if="errors.length > 0">{{ errors[0] }}</p>
        </div>
      </div>
    </validation-provider>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { mapState } from 'vuex';
import { ValidationProvider } from 'vee-validate';
import { cloneDeep } from 'lodash';

export default {
  name: 'StepConsultations',

  props: {
    tag: {
      type: String,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
  },

  model: {
    prop: 'form',
    event: 'input',
  },

  data() {
    return {
      mode: '1',
    };
  },

  methods: {
    /**
     * Select all available consultations.
     */
    selectAllAvailableConsultations() {
      this.$emit('input', {
        ...this.form,
        consultations: cloneDeep(this.consultations),
      });
    },

    /**
     * Deselect all available consultations.
     */
    deselectAllAvailableConsultations() {
      this.$emit('input', {
        ...this.form,
        consultations: [],
      });
    },

    cleanSelections() {
      this.$emit('input', {
        ...this.form,
        consultations: [],
        template: [],
      });
    },
  },

  computed: {
    ...mapState('compliance', {
      consultations: 'availableConsultations',
    }),
    ...mapState('compliance', {
      templates: 'availableTemplates',
    }),
  },

  components: {
    ValidationProvider,
    Multiselect,
  },
};
</script>

<style scoped>

</style>
